import React, { useEffect, useState } from 'react'
import './paymentdays.css'
import ChartApi from '../../charts/chart.api'

export default function PaymentDaysCard({entityFinance}) {
  const [results , setResults] = useState({})

  useEffect(()=> {
    let payLoad = {
      entityCustomerCode : entityFinance.split('/')[0]
   }
    ChartApi.getDutiesPayment(payLoad ,(data)=> {
    setResults(data.Data )
    })
  },[entityFinance])
  return (
    <div style={{ backgroundColor : "white" , padding : "1% 2%" , borderRadius : "5px" , width : "30%"  }}>
     <h4 className='is-size-5 wd_100' >Duties Payment</h4>
     <div className='paymentDaysCon is-flex is-justify-content-space-between '>
      <span style={{color : '#7D7D7D'}}>
       Total Amount (In INR)
      </span>
      <span style={{color : '#193B8A' , padding: "4%" , borderRadius : "10px" , backgroundColor : "#E1EAFF"}}>
       {results.totalAmtINR}
      </span>
     </div> 
     <div className='paymentDaysCon mt-2 is-flex is-justify-content-space-between'>
      <span style={{color : '#7D7D7D'}}>
      Total Amount (In USD)
      </span>
      <span style={{color : '#193B8A' , padding: "4%" , borderRadius : "10px" , backgroundColor : "#E1EAFF"}}>
      {results.totalAmtUSD} 
      </span>
     </div> 

      
    </div>
  )
}

